// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-d571f362&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/Sheet.vue
// module id = 458
// module chunks = 0